import { render, staticRenderFns } from "./Placed.vue?vue&type=template&id=c7d708c6&scoped=true&"
import script from "./Placed.vue?vue&type=script&lang=js&"
export * from "./Placed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7d708c6",
  null
  
)

export default component.exports